module.exports = "/_next/static/images/cardano-56a2aaa0c4b08ed739c412aaabd06e94.svg";